import { ArrowRight } from "lucide-react";
import { ReactComponent as CheckIcon } from "../../../../assets/icons/check.svg";
import Image01 from "../../../../assets/images/en01.png";
import Image02 from "../../../../assets/images/en02.png";
import Image03 from "../../../../assets/images/en03.png";
import Image04 from "../../../../assets/images/en04.png";
import Image05 from "../../../../assets/images/en05.png";

const EverythingYouNeed = () => {
  return (
    <div className="min-h-screen p-3 sm:p-6 py-8 sm:py-14">
      <div className="max-w-[95vw] sm:max-w-[90vw] lg:max-w-[85vw] mx-auto">
        <div className="text-center">
          <h1 className="text-[24px] sm:text-[28px] md:text-[36px] lg:text-[40px] xl:text-5xl font-semibold text-hColor leading-tight px-2">
            Everything You Need, All in One Place
          </h1>
        </div>

        {/* Section 1 - Vehicle Tracking */}
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between lg:space-x-12 xl:space-x-24 mt-12 sm:mt-16 lg:mt-20 xl:mt-28">
          <div className="w-full lg:w-[800px] order-2 lg:order-1 mt-6 sm:mt-8 lg:mt-0">
            <img
              src={Image01}
              alt="Vehicle Dashboard"
              className="w-full h-auto object-contain"
            />
          </div>

          <div className="w-full lg:w-[759px] flex flex-col items-start justify-center p-2 order-1 lg:order-2">
            <h1 className="text-[20px] sm:text-[24px] md:text-[32px] lg:text-[36px] xl:text-[45px] font-semibold text-hColor leading-tight">
              Vehicle Tracking & Monitoring
            </h1>
            <p className="text-pColor text-[14px] sm:text-[16px] lg:text-[18px] xl:text-[20px] my-4 sm:my-6 lg:my-8">
              Gain complete visibility and control over your fleet with
              real-time vehicle tracking and monitoring.
            </p>
            <div className="space-y-3 sm:space-y-4 lg:space-y-6 xl:space-y-8 text-[14px] sm:text-[16px] lg:text-[18px] xl:text-[20px] font-normal text-pColor">
              <div className="flex space-x-3 items-center">
                <CheckIcon className="flex-shrink-0 w-4 h-4 sm:w-5 sm:h-5" />
                <span>Fuel consumption monitoring to cut costs.</span>
              </div>
              <div className="flex space-x-3 items-center">
                <CheckIcon className="flex-shrink-0 w-4 h-4 sm:w-5 sm:h-5" />
                <span>Real-time GPS tracking with geofencing.</span>
              </div>
              <div className="flex space-x-3 items-center">
                <CheckIcon className="flex-shrink-0 w-4 h-4 sm:w-5 sm:h-5" />
                <span>Fuel consumption monitoring to cut costs.</span>
              </div>
              <div className="flex space-x-3 items-center">
                <CheckIcon className="flex-shrink-0 w-4 h-4 sm:w-5 sm:h-5" />
                <span>Detailed trip history and analytics.</span>
              </div>
            </div>
            <button className="flex items-center space-x-2 group text-[14px] sm:text-[16px] lg:text-[18px] xl:text-[20px] text-pColor mt-6 sm:mt-8 lg:mt-10 xl:mt-14">
              <span>Learn more</span>
              <ArrowRight className="w-4 h-4 sm:w-5 sm:h-5 group-hover:translate-x-1 transition-transform" />
            </button>
          </div>
        </div>

        {/* Section 2 - Driver Management */}
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between lg:space-x-12 xl:space-x-24 mt-12 sm:mt-16 lg:mt-20 xl:mt-28">
          <div className="w-full lg:w-[759px] flex flex-col items-start justify-center p-2 order-2 lg:order-1">
            <h1 className="text-[20px] sm:text-[24px] md:text-[32px] lg:text-[36px] xl:text-[45px] font-semibold text-hColor leading-tight">
              Driver Management & Trip Analytics
            </h1>
            <p className="text-pColor text-[14px] sm:text-[16px] lg:text-[18px] xl:text-[20px] my-4 sm:my-6 lg:my-8">
              Gain full visibility into your drivers' performance and trip
              activities with real-time tracking, automated trip logs, and route
              optimization.
            </p>
            <div className="space-y-3 sm:space-y-4 lg:space-y-6 xl:space-y-8 text-[14px] sm:text-[16px] lg:text-[18px] xl:text-[20px] font-normal text-pColor">
              <div className="flex space-x-3 items-center">
                <CheckIcon className="flex-shrink-0 w-4 h-4 sm:w-5 sm:h-5" />
                <span>Assign vehicles to drivers and their trips.</span>
              </div>
              <div className="flex space-x-3 items-center">
                <CheckIcon className="flex-shrink-0 w-4 h-4 sm:w-5 sm:h-5" />
                <span>Driver performance reports to improve efficiency.</span>
              </div>
              <div className="flex space-x-3 items-center">
                <CheckIcon className="flex-shrink-0 w-4 h-4 sm:w-5 sm:h-5" />
                <span>Automated trip logging for accurate data.</span>
              </div>
            </div>
            <button className="flex items-center space-x-2 group text-[14px] sm:text-[16px] lg:text-[18px] xl:text-[20px] text-pColor mt-6 sm:mt-8 lg:mt-10 xl:mt-14">
              <span>Learn more</span>
              <ArrowRight className="w-4 h-4 sm:w-5 sm:h-5 group-hover:translate-x-1 transition-transform" />
            </button>
          </div>

          <div className="w-full lg:w-[800px] order-1 lg:order-2 mt-6 sm:mt-8 lg:mt-0">
            <img
              src={Image02}
              alt="Vehicle Dashboard"
              className="w-full h-auto object-contain"
            />
          </div>
        </div>

        {/* Section 3 - Maintenance Management */}
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between lg:space-x-12 xl:space-x-24 mt-12 sm:mt-16 lg:mt-20 xl:mt-28">
          <div className="w-full lg:w-[800px] order-2 lg:order-1 mt-6 sm:mt-8 lg:mt-0">
            <img
              src={Image03}
              alt="Vehicle Dashboard"
              className="w-full h-auto object-contain"
            />
          </div>

          <div className="w-full lg:w-[759px] flex flex-col items-start justify-center p-2 order-1 lg:order-2">
            <h1 className="text-[20px] sm:text-[24px] md:text-[32px] lg:text-[36px] xl:text-[45px] font-semibold text-hColor leading-tight">
              Maintenance Management
            </h1>
            <p className="text-pColor text-[14px] sm:text-[16px] lg:text-[18px] xl:text-[20px] my-4 sm:my-6 lg:my-8">
              Fleet Pro helps you prevent unexpected breakdowns by providing
              real-time alerts for scheduled servicing, inspections, and
              repairs.
            </p>
            <div className="space-y-3 sm:space-y-4 lg:space-y-6 xl:space-y-8 text-[14px] sm:text-[16px] lg:text-[18px] xl:text-[20px] font-normal text-pColor">
              <div className="flex space-x-3 items-center">
                <CheckIcon className="flex-shrink-0 w-4 h-4 sm:w-5 sm:h-5" />
                <span>
                  Instant alerts for repairs, servicing, and fuel levels.
                </span>
              </div>
              <div className="flex space-x-3 items-center">
                <CheckIcon className="flex-shrink-0 w-4 h-4 sm:w-5 sm:h-5" />
                <span>Automated maintenance scheduling.</span>
              </div>
              <div className="flex space-x-3 items-center">
                <CheckIcon className="flex-shrink-0 w-4 h-4 sm:w-5 sm:h-5" />
                <span>Real-time GPS tracking with geofencing.</span>
              </div>
            </div>
            <button className="flex items-center space-x-2 group text-[14px] sm:text-[16px] lg:text-[18px] xl:text-[20px] text-pColor mt-6 sm:mt-8 lg:mt-10 xl:mt-14">
              <span>Learn more</span>
              <ArrowRight className="w-4 h-4 sm:w-5 sm:h-5 group-hover:translate-x-1 transition-transform" />
            </button>
          </div>
        </div>

        {/* Section 4 - Profit & Expense Monitoring */}
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between lg:space-x-12 xl:space-x-24 mt-12 sm:mt-16 lg:mt-20 xl:mt-28">
          <div className="w-full lg:w-[759px] flex flex-col items-start justify-center p-2 order-2 lg:order-1">
            <h1 className="text-[20px] sm:text-[24px] md:text-[32px] lg:text-[36px] xl:text-[45px] font-semibold text-hColor leading-tight">
              Profit & Expense Monitoring
            </h1>
            <p className="text-pColor text-[14px] sm:text-[16px] lg:text-[18px] xl:text-[20px] my-4 sm:my-6 lg:my-8">
              Keep track of your fleet's financial performance with real-time
              profit and expense monitoring.
            </p>
            <div className="space-y-3 sm:space-y-4 lg:space-y-6 xl:space-y-8 text-[14px] sm:text-[16px] lg:text-[18px] xl:text-[20px] font-normal text-pColor">
              <div className="flex space-x-3 items-center">
                <CheckIcon className="flex-shrink-0 w-4 h-4 sm:w-5 sm:h-5" />
                <span>Track earnings per vehicle.</span>
              </div>
              <div className="flex space-x-3 items-center">
                <CheckIcon className="flex-shrink-0 w-4 h-4 sm:w-5 sm:h-5" />
                <span>Expense breakdown for fuel, maintenance, and more.</span>
              </div>
              <div className="flex space-x-3 items-center">
                <CheckIcon className="flex-shrink-0 w-4 h-4 sm:w-5 sm:h-5" />
                <span>Financial reports for better decision-making.</span>
              </div>
            </div>
            <button className="flex items-center space-x-2 group text-[14px] sm:text-[16px] lg:text-[18px] xl:text-[20px] text-pColor mt-6 sm:mt-8 lg:mt-10 xl:mt-14">
              <span>Learn more</span>
              <ArrowRight className="w-4 h-4 sm:w-5 sm:h-5 group-hover:translate-x-1 transition-transform" />
            </button>
          </div>

          <div className="w-full lg:w-[800px] order-1 lg:order-2 mt-6 sm:mt-8 lg:mt-0">
            <img
              src={Image04}
              alt="Vehicle Dashboard"
              className="w-full h-auto object-contain"
            />
          </div>
        </div>

        {/* Section 5 - Reporting & Analytics */}
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between lg:space-x-12 xl:space-x-24 mt-12 sm:mt-16 lg:mt-20 xl:mt-28 mb-8 sm:mb-12 lg:mb-16">
          <div className="w-full lg:w-[800px] order-2 lg:order-1 mt-6 sm:mt-8 lg:mt-0">
            <img
              src={Image05}
              alt="Vehicle Dashboard"
              className="w-full h-auto object-contain"
            />
          </div>
          <div className="w-full lg:w-[759px] flex flex-col items-start justify-center p-2 order-1 lg:order-2">
            <h1 className="text-[20px] sm:text-[24px] md:text-[32px] lg:text-[36px] xl:text-[45px] font-semibold text-hColor leading-tight">
              Reporting & analytics
            </h1>
            <p className="text-pColor text-[14px] sm:text-[16px] lg:text-[18px] xl:text-[20px] my-4 sm:my-6 lg:my-8">
              Make smarter fleet decisions with real-time analytics and
              automated reports.
            </p>
            <div className="space-y-3 sm:space-y-4 lg:space-y-6 xl:space-y-8 text-[14px] sm:text-[16px] lg:text-[18px] xl:text-[20px] font-normal text-pColor">
              <div className="flex space-x-3 items-center">
                <CheckIcon className="flex-shrink-0 w-4 h-4 sm:w-5 sm:h-5" />
                <span>Customizable dashboards with key fleet metrics.</span>
              </div>
              <div className="flex space-x-3 items-center">
                <CheckIcon className="flex-shrink-0 w-4 h-4 sm:w-5 sm:h-5" />
                <span>Downloadable reports for performance tracking.</span>
              </div>
              <div className="flex space-x-3 items-center">
                <CheckIcon className="flex-shrink-0 w-4 h-4 sm:w-5 sm:h-5" />
                <span>Insights for cost reduction and optimization..</span>
              </div>
            </div>
            <button className="flex items-center space-x-2 group text-[14px] sm:text-[16px] lg:text-[18px] xl:text-[20px] text-pColor mt-6 sm:mt-8 lg:mt-10 xl:mt-14">
              <span>Learn more</span>
              <ArrowRight className="w-4 h-4 sm:w-5 sm:h-5 group-hover:translate-x-1 transition-transform" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EverythingYouNeed;
